import AppForm from '../../app-components/Form/AppForm';

Vue.component('tabs-form-upload', {
    mixins: [AppForm],
    emits: ['successfull-upload', 'tab-upload-content'],
    data: function() {
        return {
            form: {
                alias_name:  '' ,
                app_factories_id:  '' ,
                
            },
            tempFactory: null,
            info:  {},
        }
    },
    computed: {
    },
    methods:{
        onUpdateFactory(appFactory) {
            if (appFactory !== null) {
                this.form.app_factories_id = appFactory.id;
            }else{
                this.form.app_factories_id = "";
            }
        },
        onRemoveFactory(appFactory) {
            this.form.app_factories_id = "";
        },
        uploadFile(evt){
            const superObj = this

            /* superObj.$emit('successfull-upload', {test: 'test'}) */

            this.sourceFile = this.$refs.file.files[0]

            const formData = new FormData();
            formData.append('sourcefile', this.sourceFile);
            formData.append('app_factories_id', superObj.form.app_factories_id);
            formData.append('alias_name', superObj.form.alias_name);
            const headers = { 'Content-Type': 'multipart/form-data' };

            axios.post(`${this.uploadUrlOnly}`, formData, { headers }).then((res) => {
                const result = res.data
                const { data, info } = result
                this.info = info
                superObj.$emit('successfull-upload', data)
            
            }).catch(function (error) {
                if (error.response) {
                    const { message, statusText } = error.response.data
                    const { message: axiosMessage } = error
                    superObj.$notify({
                        type: 'error',
                        title: 'Error!',
                        text: `${message} (${axiosMessage})`
                    });
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
            
              });
        },
        resetFile(){
            this.form.column_maps = []
            /* console.log('this.$refs.file', this.$refs.file) */
            this.$refs.file.value = null
        },
        eventClick(){
            /* this.$emit('successfull-upload', {test: 'test'}) */
        }
    },
    props: {
        uploadUrlOnly:{
            type: String,
            default:""
        },
    },
    mounted: function () {  
    }

});